import { useState } from 'react';

import { SocketInternalEvents } from '@libs/socket-signalr';
import { Subscription } from '@libs/subscription';

import { GameSocketEvents, useGameSocket } from '@features/shared/api/game';

type IGameSubscription = {
  subscribe: (cb: (e: GameSocketEvents | SocketInternalEvents) => void) => () => void;
};

export function useGameSubscription({
  gameId,
  customSocketUrl,
  customAccessToken,
  enabled = true,
}: {
  gameId: string;
  customSocketUrl?: string;
  customAccessToken?: string;
  enabled?: boolean;
}): IGameSubscription {
  const [socketSubscription] = useState(
    () => new Subscription<GameSocketEvents | SocketInternalEvents>(),
  );
  useGameSocket({
    gameId,
    customSocketUrl,
    customAccessToken,
    enabled,
    cb: (e) => {
      socketSubscription.publish(e);
    },
  });

  return socketSubscription;
}
